import React, { useMemo, useState } from 'react';
import { Form } from 'components/atoms';
import { Formik, Field } from 'formik';
import {
  FieldSelect, FieldCustom, FieldTextarea
} from 'components/molecules';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useDebounce } from 'react-use'


const Schema = Yup.object().shape({
  text: Yup.string().required('Campo obrigatório'),
  number: Yup.string()
    .min(1, 'Mínimo de 1 carácter')
    .max(4, 'Máximo de 3 caracteres')
    .required('Campo obrigatório'),
});
const SchemaResult = Yup.object().shape({
  data: Yup.array(),

});
const OneFactEditor = ({ initialProps, onChange }) => {
  const [editorProps, setEditorProps] = useState(initialProps)

  const initialValues = useMemo(() => {
    const { data, backgroundColor } = initialProps;
    const number = data.length >= 0 ? data[0] : ''
    const text = data.length >= 1 ? data[1] : ''

    return { number, text, backgroundColor };
  }, [initialProps]);

  const handleFormChange = newValues => {
    const { number, text, backgroundColor } = newValues;
    let isThemeReverse = false
    if (backgroundColor !== '#FFF') isThemeReverse = true

    const data = [number, text]
    const newProps = {
      ...initialProps, data, backgroundColor, isThemeReverse
    };

    const isValid = SchemaResult.isValidSync(newProps)
    if (isValid) setEditorProps(newProps)
  };

  useDebounce(() => {
    onChange(editorProps);
  }, 200,
  [editorProps]
  )

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Schema}
      validate={handleFormChange}
    >
      <Form>
        <Field
          title="Texto"
          name="text"
          info="Texto do destaque"
          component={FieldTextarea}
        />
        <Field
          title="Número"
          name="number"
          info="Número do destaque"
          component={FieldCustom}
        />
        <Field
          title="Cor"
          name="backgroundColor"
          info="cor de fundo"
          component={FieldSelect}
          options={[
            { value: '#FFF', label: 'Branco' },
            { value: '#000', label: 'Preto' },
            { value: '#404041', label: 'Cinza' }
          ]}
        />
      </Form>
    </Formik>
  );
};
OneFactEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialProps: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.string)
  }),
};

OneFactEditor.defaultProps = {
  initialProps: {},
};

export default OneFactEditor;
